export default __webpack_public_path__ + "static/media/Dienstleister.51f5f480.png";